export default __webpack_public_path__ + "static/2-5c5230a854e7f62e8ad56e138803895d.jpg";